<template>
	<div>
        <div class="text-center">
            <h5>{{ $t('assets.categoryAssetAllocation') }}</h5>
        </div>
        <div v-if="responsive == 'PC'" :id="id" style="height: 360px"></div>
        <div v-if="responsive != 'PC'" :id="id" style="height: 240px"></div>
        <div class="mt-8 fs-14 grey--text float-right">{{ $t('assets.dataStatisticsTime') }}: {{ formatDateTime(dataUpdateTimestamp) }}</div>
	</div>
</template>
<style>

</style>
<script>
    import Vue from 'vue'
    import config from '@/config.js';
    import Highcharts from 'highcharts/highstock';
    import { mapGetters } from "vuex";
    export default {
        data(){
            return {
                id: 'categoryAssetAllocationPieChart',
                dataUpdateTimestamp: null,
                option: {
                    chart: {
                        backgroundColor: this.darkMode ? 'dark' : '',
                        renderTo: 'categoryAssetAllocationPieChart',
                        type: 'pie'
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat: 'Total Value: ${point.totalValue:.2f}<br/>Percentage: <b>{point.percentage:.2f}%</b>'
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                distance: 0,
                                format: '<b>{point.name}</b>: {point.percentage:.2f} %',
                                style: {
                                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                }
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        colorByPoint: true,
                        innerSize: '50%',
                        data: null
                    }],
                    // 图例导航
                    legend: {
                        enabled: true,
                        itemStyle: {
                            color: '#999999'
                        },
                        itemHoverStyle: {
                            color: '#999999'
                        },
                        itemHiddenStyle: {
                            color: '#606063'
                        },
                        title: {
                            style: {
                                color: '#C0C0C0',
                                fontFamily: '\'Lexend Deca\', sans-serif'
                            }
                        }
                    },
                    noData: {
                        style: {
                            fontWeight: 'bold',
                            fontSize: '15px',
                            color: '#303030'
                        }
                    },
                    // 版权信息
                    credits: {
                        enabled: false
                    },
                    // 导出图片
                    exporting: {
                        enabled: false,
                        filename: 'Excgange-Assets-Allocation-Pie-Chart',
                        buttons: {
                            contextButton: {
                                align: "left",
                                verticalAlign: "top",
                                x: 1,
                                y: 0
                            }
                        }
                    },
                }
            }
        },
        created(){
            this.getAssetAllocationAtCategory();
        },
        mounted(){
            // 不是PC版不显示提示信息
            if (this.responsive != 'PC') {
                this.option.plotOptions.pie.dataLabels.enabled = false;
            }
            Highcharts.chart(this.id, this.option);
        },
        computed: {
            ...mapGetters(['darkMode', 'responsive', 'time'])
        },
        watch:{

        },
        methods: {
            getAssetAllocationAtCategory(){
                let api = config.baseUrl + '/asset/analysis/private/allocation/category';
                this.$http.get(api).then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.dataUpdateTimestamp = data.result.updateTimestamp;
                        let allocationDataList = data.result.data;
                        for(let i = 0, len = allocationDataList.length; i < len; i++){
                            let name = allocationDataList[i].name;
                            let color = null;
                            switch(name){
                                case 'Funding': color = '#9785fb'; break;
                                case 'Spot': color = '#4CAF50'; break;
                                case 'Coin Swap': color = '#F0B90B'; break;
                                case 'USDT Swap': color = '#FEE108'; break;
                                default: break;
                            }
                            allocationDataList[i].color = color;
                        }
                        this.option.series[0].data = allocationDataList;
                        Highcharts.chart(this.id, this.option);
                    } 
                }, error => {

                });
            },
            // 格式化时间
            formatDateTime(timestamp){
                if('UTCTime' == this.time){
                    return formatUTCTime(timestamp);
                }else{
                    return formatTime(timestamp);
                }
            },
        }
    }
</script>
